export const undefinedNumberFormatter = (value?: number): string => {
    if (value === undefined) {
        return "";
    }

    return `${value}`;
};
